import React, { memo, useMemo } from "react";
import { PageContainer, GridBox, Box, Header, Link, useMatchMedia, Paragraph, useSsr } from "@pochta/ui";
import isIOS from "../../../../helpers/isIOS";
import isMobileDevice from "../../../../helpers/isMobileDevice";
import { ErrorPageMain, ErrorPageWrapper, ErrorPageQr, ErrorPageQrId } from "./ErrorPage.styles";
import ErrorPageLogo from "./components/ErrorPageLogo";
import ErrorPageApps from "./components/ErrorPageApps";

var MaintenancePage = function MaintenancePage(_ref) {
  var _ref$isPochtaId = _ref.isPochtaId,
      isPochtaId = _ref$isPochtaId === void 0 ? false : _ref$isPochtaId,
      _ref$mainPage = _ref.mainPage,
      mainPage = _ref$mainPage === void 0 ? null : _ref$mainPage,
      _ref$appStore = _ref.appStore,
      appStore = _ref$appStore === void 0 ? null : _ref$appStore,
      _ref$googlePlay = _ref.googlePlay,
      googlePlay = _ref$googlePlay === void 0 ? null : _ref$googlePlay;
  var mobile = useMatchMedia("mobile");

  var _useSsr = useSsr(),
      isSsr = _useSsr.isSsr;

  var isMobSafari = useMemo(function () {
    return isSsr ? false : isIOS() && isMobileDevice();
  }, [isSsr]);
  return /*#__PURE__*/React.createElement(ErrorPageMain, null, /*#__PURE__*/React.createElement(PageContainer, null, /*#__PURE__*/React.createElement(ErrorPageWrapper, null, /*#__PURE__*/React.createElement(GridBox, {
    row: true,
    flexbox: true,
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(GridBox, {
    xs: 12,
    sm: 6,
    xl: 6
  }, /*#__PURE__*/React.createElement(ErrorPageLogo, {
    mobileCentered: true,
    isMobile: mobile
  }), /*#__PURE__*/React.createElement(Header, {
    withPaddingTop: true,
    textAlign: mobile ? "center" : "left"
  }, "\u0414\u0435\u043B\u0430\u0435\u043C \u0441\u0430\u0439\u0442 \u043B\u0443\u0447\u0448\u0435"), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Paragraph, {
    size: "l",
    textAlign: mobile ? "center" : "left"
  }, "\u041C\u044B \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u043B\u0438 \u0434\u043E\u0441\u0442\u0443\u043F \u043D\u0430 \u0441\u0430\u0439\u0442, \u0447\u0442\u043E\u0431\u044B \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0435\u0433\u043E \u043B\u0443\u0447\u0448\u0435. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0451 \u0440\u0430\u0437 \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0438\u043B\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u2014 \u0442\u0430\u043C \u0432\u0441\u0451, \u0447\u0442\u043E \u043D\u0443\u0436\u043D\u043E."), /*#__PURE__*/React.createElement(ErrorPageApps, {
    mobileCentered: true,
    isMobile: mobile,
    isMobSafari: isMobSafari,
    appStore: appStore,
    googlePlay: googlePlay
  }), !mobile && /*#__PURE__*/React.createElement(Paragraph, {
    size: "l"
  }, "...\u0438\u043B\u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430", " ", /*#__PURE__*/React.createElement(Link, {
    underline: "none",
    href: mainPage
  }, "\u0433\u043B\u0430\u0432\u043D\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.")))), !mobile && /*#__PURE__*/React.createElement(GridBox, {
    sm: 6,
    xl: 6,
    flexbox: true,
    justifyContent: "flex-end"
  }, isPochtaId ? /*#__PURE__*/React.createElement(ErrorPageQrId, null) : /*#__PURE__*/React.createElement(ErrorPageQr, null))))));
};

export default /*#__PURE__*/memo(MaintenancePage);